import angular from 'angular'

import setCss from './set-css'
import envRaw from './env-raw'
import Emitter from './emitter'
import ResizeDetector from './resize-detector'

angular
  .module('ggs.utils')
  .factory('fontEmitter', fontEmitterProvider)

function fontEmitterProvider(
  domh,
  $log,
  $rootScope,
  addIdPrefix,
  $rootElement) {

  const tester = document.createElement('div')
  tester.id = addIdPrefix('font-tester')
  tester.textContent = 'BESbswy'
  tester.setAttribute('aria-hidden', 'true')
  setCss(tester, {
    top: -10000,
    left: -10000,
    position: 'absolute'
  })

  const fontEmitter = Emitter().setMaxListeners(1000)
  const resizeDetector = ResizeDetector(tester)
  $rootElement.append(tester)
  resizeDetector.on(handler)

  $rootScope.$on('$destroy', () => {
    resizeDetector.off(handler)
    domh.remove.notStrict(tester)
  })

  return fontEmitter

  function handler() {
    fontEmitter.emit()

    if (envRaw.showsFontEmitterDebug) {
      $log.force.debug(`${Date.now()} !fontEmitter`)
    }
  }
}
